module.exports = __webpack_public_path__ + "media/images/shared/ebt-logo-1b84fbec514dfbca84f744b6d51157e7c20b1e1c300ddb1f1105f15305b9f964.png";